// Site background: Frolik orange
// shell (peach gradient, a soft white glow in the middle, a soft highlight
// top-left, a deeper shadow bottom-right). The top is darkened slightly so the white frog button and
// search bar stand out. Keep in sync with --page-bg in index.css.
export const HOME_BACKGROUND =
  '#FF7A00';
// Solid colour of the top edge of the site background (status bar / browser bar).
export const HOME_THEME_COLOR = '#FF7A00';

// Background choices for new events: gradients styled like the home page
// (diagonal, three stops). Older events may still have a solid hex colour,
// which everything below continues to support.

export const BACKGROUND_CHOICES = [
  { label: 'Cream gradient', value: 'linear-gradient(135deg, #FFFBEF 0%, #F8F2DC 48%, #E9D9AE 100%)' },
  { label: 'Pink gradient', value: 'linear-gradient(135deg, #FFC9CD 0%, #F29CA3 48%, #E2697A 100%)' },
  { label: 'Yellow gradient', value: 'linear-gradient(135deg, #FFFF9E 0%, #FFF200 48%, #FFC300 100%)' },
];

// Colour stops of a background value, e.g. [{ color: '#F8F2DC', at: 0.48 }, ...].
// A plain colour returns a single stop.
export function backgroundStops(value) {
  const matches = [...String(value || '').matchAll(/(#[0-9a-f]{3,8})(?:\s+(\d{1,3})%)?/gi)];
  return matches.map((match, index) => ({
    color: match[1],
    at: match[2] !== undefined
      ? Math.min(Number(match[2]), 100) / 100
      : matches.length > 1 ? index / (matches.length - 1) : 0,
  }));
}

// One representative colour, for places that can't show a gradient
// (browser theme colour, choosing readable text colours).
export function primaryColor(value, fallback = '#FF7A00') {
  const stops = backgroundStops(value);
  if (!stops.length) return fallback;
  return stops[Math.floor(stops.length / 2)].color;
}
